Ext.define('SA.view.NewView', {
    alias: 'widget.new-view',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-new-view',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-new-view-header',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-new-view-header-title',
                        html: 'New View'
                    }, {
                        xtype: 'historical-toggle',
                        hidden: true,
                        country: this.countryModel
                    }
                ]
            }, {
                xtype: 'component',
                cls: 'sa-new-view-no-views-message',
                hidden: true,
                itemId: 'noViewsMessage',

                html: [
                    '<span class="sa-new-view-no-views-message-lead">',
                        'Please create a new view and add some locations and data variables to get started. ',
                    '</span>',
                    '<span class="sa-new-view-no-views-message-aside">',
                        'If you have any questions or issues click on the support button at the top of the page.',
                    '</span>'
                ]
            }, {
                xtype: 'new-view-list'
            }
        ];

        this.callParent();

        this.historicalToggle = this.down('historical-toggle');
        this.noViewsMessage = this.down('#noViewsMessage');
        this.viewList = this.down('new-view-list');
    },

    initEvents() {
        this.callParent();

        this.mon(this.up('project-view'), 'beforeshow', this.refreshViewList, this);

        this.historicalToggle.on('change:checkbox', this.refreshViewList, this);
        this.historicalToggle.on('select:release', this.refreshViewList, this);
        this.viewList.on('click:createView', this.onClickCreateView, this);
    },

    onClickCreateView({type}) {
        this.fireEvent('click:createView', {type, censusRelease: this.getSelectedRelease()});
    },

    getSelectedRelease() {
        return this.historicalToggle.getSelectedRelease();
    },

    refreshViewList() {
        var countryCode = this.countryCode,
            censusReleaseYear = this.getSelectedRelease(),
            tplData = SA.view.ViewTypes.getNewViewScreenViewListData({countryCode, censusReleaseYear});

        this.viewList.update(tplData);
    },

    setHistoricalViewsEnabled(enabled) {
        this.historicalToggle.setEnabled(enabled);
        this.refreshViewList();
    },

    setNoViewsMessageVisible(visible) {
        this.noViewsMessage.setVisible(visible);
    }
});